import React from 'react';

import { RequestButton } from '@common/react/components/UI/LoadingButton/LoadingButton';

import { BaseTestSession } from '@commonTuna/react/objects/BaseTestSession';

interface ComponentProps {
	session: BaseTestSession;
	afterCopy?: (res: BaseTestSession) => void;
	caption?: any;
	btnClassName?: string;
	disabled?: boolean;
}

const CopyForward: React.FC<ComponentProps> = ({
	afterCopy,
	session,
	caption,
	btnClassName,
	disabled,
}) => {
	return <RequestButton<BaseTestSession>
		requestType="questionnaireFormCopyForward"
		type="button"
		requestProps={{
			appointmentId: session.appointmentId,
			diseaseId: session.diseaseId,
			oldTestSessionId: session.oldTestSessionId,
		}}
		successMessage="Answers successfully copied!"
		onSuccess={({ res, success }) => {
			if (res) {
				success();
				afterCopy?.(res);
			}
		}}
		className={btnClassName || 'btn btn-primary'}
		title="Copy forward"
		disabled={(session && session.askAlways) || disabled}
	>
		{caption || <i className="fa fa-clone" />}
	</RequestButton>;
};

export default CopyForward;
